<script>
import request from "@/utils/request";
import { mapGetters } from "vuex";

export default {
  name: "QuarterCompare",
  data() {
    return {
      loading: false,
      prevData: { year: "", quarter: "", reachCount: 0, incrementCount: 0 },
      currData: { year: "", quarter: "", reachCount: 0, incrementCount: 0 },
      badgeNum: 0,
    };
  },
  computed: {
    ...mapGetters(["userInfo", "is999", "token"]),
    show() {
      return this.is999 && this.token
    }
  },
  mounted() {
    if (this.show) {
      this.fetchData();
    }
  },
  methods: {
    getQuarterInfo(date) {
      const year = date.getFullYear();
      const month = date.getMonth();
      const quarter = Math.floor(month / 3) + 1;
      return { year: String(year), quarter: `${quarter}` };
    },
    fetchData() {
      this.loading = true;
      // 接口异常时用于兜底展示当前季度
      const curr = this.getQuarterInfo(new Date());
      const prev = { year: String(Number(curr.year) - 1), quarter: curr.quarter };

      request
        .post("/saasconfig/getHospitalProfitDetail", {
          hospitalCode: this.userInfo.hosptialCode,
        })
        .then((res) => {
          const d = res.result || {};
          const lastYear = d.lastYear || {};
          const thisYear = d.thisYear || {};
          this.prevData = {
            year: lastYear.yearly || "",
            quarter: lastYear.quarter || "",
            reachCount: lastYear.qualifyQuantity || 0,
            incrementCount: lastYear.incrementQuantity || 0,
          };
          this.currData = {
            year: thisYear.yearly || "",
            quarter: thisYear.quarter || "",
            reachCount: thisYear.qualifyQuantity || 0,
            incrementCount: thisYear.incrementQuantity || 0,
          };
        })
        .catch(() => {
          // 接口未就绪时使用默认值
          this.prevData = { year: prev.year, quarter: prev.quarter, reachCount: 0, incrementCount: 0 };
          this.currData = { year: curr.year, quarter: curr.quarter, reachCount: 0, incrementCount: 0 };
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<template>
  <div class="quarter-compare" v-if="show">
    <!-- 上一年季度 -->
    <div class="quarter-card prev">
      <span class="quarter-title">{{ prevData.year }}年 第{{ prevData.quarter }}季度</span>
      <div class="metric">
        <span class="label">达标患者</span>
        <span class="value">{{ prevData.reachCount.toLocaleString() }}<span class="unit">人</span></span>
      </div>
      <div class="metric">
        <span class="label">增量帖数</span>
        <span class="value">{{ prevData.incrementCount.toLocaleString() }}<span class="unit">帖</span></span>
      </div>
    </div>

    <!-- 当前季度 -->
    <div class="quarter-card curr">
      <span class="quarter-title red2">{{ currData.year }}年 第{{ currData.quarter }}季度</span>
      <div class="metric">
        <span class="label red2">达标患者</span>
        <span class="value">{{ currData.reachCount.toLocaleString() }}<span class="unit">人</span></span>
      </div>
      <div class="metric">
        <span class="label red2">增量帖数</span>
        <span class="value">{{ currData.incrementCount.toLocaleString() }}<span class="unit">帖</span></span>
      </div>
    </div>

    <div class="bg"></div>
    <Spin v-if="loading" fix></Spin>
  </div>
</template>


<style lang="scss" scoped>
.quarter-compare {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  height: 35px;
  position: relative;
  background: #fff;
  border-bottom: 1px solid #ddd;

  .bg {
    background: #fff4f3;
    position: absolute;
    top: 0;
    right: 0;
    width: 50%;
    height: 100%;
    border-left: 2px solid #853a2f;
  }
}

.quarter-card .metric .label.red2,
.red2 {
  color: #853a2f;
  opacity: 1;
}

.quarter-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 50px;
  position: relative;
  z-index: 3;

  .quarter-title {
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;

  }

  .metric {
    display: flex;
    align-items: baseline;
    gap: 6px;

    .label {
      font-size: 12px;
      opacity: 0.6;
    }

    .value {
      font-size: 18px;
      font-weight: 700;

      .unit {
        font-size: 12px;
        font-weight: 400;
        margin-left: 2px;
        opacity: 0.6;
      }
    }
  }
}

.badge {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 4px;
  background: #f5a623;
  border-radius: 4px;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}

.divider {
  width: 1px;
  height: 32px;
  background: #e0e0e0;
}
</style>